import $ from 'jquery'

$(document).ready(function() {
  $( '#bookRide' ).on('shown.bs.modal', function(){
    $('.bk-choose-date').trigger('click')
  });
})
